// extracted by mini-css-extract-plugin
module.exports = {"container":"i_bs","top":"i_bt","link":"i_bu","active":"i_bv","icon":"i_bw","label":"i_bx","item":"i_by"};